module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"sms_rate":"SMS Rate"},"zh":{"sms_rate":"簡訊儲值費率"}}')
  delete Component.options._Ctor
}
